import { AreaItem } from '@/types/cms/AreaItem'
import { notifyError } from '@/libs/bugsnag/bugsnag'
import React from 'react'
import AppContext from '@/types/context'

type DynamicRendererProps = {
  name: string
  registry: any
  item: AreaItem
  context: AppContext
}

const DynamicRenderer = ({ name, registry, context, item }: DynamicRendererProps) => {
  const Component = registry[name]
  if (!Component) {
    notifyError(`Element ${name} not found, so it could not be rendered`, { scope: 'DynamicRenderer', element: name })
    return null
  }
  const MemoDynamic = React.memo(Component)
  // @ts-ignore
  return <MemoDynamic context={context} item={item} />
}

export default DynamicRenderer
